/* =========================================================
   ES: Disable tooltips site-wide
   - Removes native browser "title" tooltips
   - Disposes Bootstrap/jQuery tooltips & popovers if present
   - Watches dynamically injected DOM (mini cart, quickview, etc.)
   ========================================================= */
(function () {
  "use strict";

  function ensureAriaLabel(el, title) {
    try {
      if (!el.getAttribute("aria-label") && title && title.trim()) {
        el.setAttribute("aria-label", title.trim());
      }
    } catch (e) {}
  }

  function stripTitle(el) {
    try {
      if (!el || el.nodeType !== 1) return;
      var title = el.getAttribute("title");
      if (title == null) return;

      // Keep accessibility text, but remove hover tooltip
      ensureAriaLabel(el, title);

      // Store original title in case you ever need it back
      el.setAttribute("data-es-title", title);
      el.removeAttribute("title");
    } catch (e) {}
  }

  function stripBootstrapTooltipAttrs(el) {
    try {
      if (!el || el.nodeType !== 1) return;

      // Remove BS4/BS5 tooltip/popover triggers and cached titles
      var dt = el.getAttribute("data-toggle");
      if (dt === "tooltip" || dt === "popover") el.removeAttribute("data-toggle");

      var dbt = el.getAttribute("data-bs-toggle");
      if (dbt === "tooltip" || dbt === "popover") el.removeAttribute("data-bs-toggle");

      el.removeAttribute("data-original-title");
      el.removeAttribute("data-bs-original-title");
      el.removeAttribute("aria-describedby");
    } catch (e) {}
  }

  function process(root) {
    try {
      if (!root) root = document;

      // Native title tooltips
      if (root.querySelectorAll) {
        var titled = root.querySelectorAll("[title]");
        for (var i = 0; i < titled.length; i++) stripTitle(titled[i]);

        // Bootstrap triggers
        var bs = root.querySelectorAll(
          '[data-toggle="tooltip"],[data-toggle="popover"],[data-bs-toggle="tooltip"],[data-bs-toggle="popover"]'
        );
        for (var j = 0; j < bs.length; j++) stripBootstrapTooltipAttrs(bs[j]);
      }
    } catch (e) {}
  }

  function disposeFrameworkTooltips() {
    // Bootstrap 5
    try {
      if (window.bootstrap && window.bootstrap.Tooltip) {
        var els = document.querySelectorAll('[data-bs-toggle="tooltip"],[data-toggle="tooltip"]');
        for (var i = 0; i < els.length; i++) {
          try {
            var inst = window.bootstrap.Tooltip.getInstance(els[i]);
            if (inst) inst.dispose();
          } catch (e) {}
        }
      }
      if (window.bootstrap && window.bootstrap.Popover) {
        var els2 = document.querySelectorAll('[data-bs-toggle="popover"],[data-toggle="popover"]');
        for (var j = 0; j < els2.length; j++) {
          try {
            var inst2 = window.bootstrap.Popover.getInstance(els2[j]);
            if (inst2) inst2.dispose();
          } catch (e) {}
        }
      }
    } catch (e) {}

    // Bootstrap 4 / jQuery tooltip
    try {
      if (window.jQuery && window.jQuery.fn) {
        var $ = window.jQuery;
        if ($.fn.tooltip) {
          try { $('[data-toggle="tooltip"]').tooltip('dispose'); } catch (e) {}
        }
        if ($.fn.popover) {
          try { $('[data-toggle="popover"]').popover('dispose'); } catch (e) {}
        }
      }
    } catch (e) {}
  }

  // Prevent native tooltips by stripping title early
  document.addEventListener(
    "mouseover",
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest("[title]") : null;
      if (el) stripTitle(el);
    },
    true
  );
  document.addEventListener(
    "focusin",
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest("[title]") : null;
      if (el) stripTitle(el);
    },
    true
  );

  // Initial pass + framework disposal
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      process(document);
      disposeFrameworkTooltips();
    });
  } else {
    process(document);
    disposeFrameworkTooltips();
  }

  // Watch dynamic DOM updates (mini-cart, quickview, ajax sections)
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (!m.addedNodes) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node && node.nodeType === 1) process(node);
        }
      }
      // Keep disposing in case something re-inits
      disposeFrameworkTooltips();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
